module.exports = __webpack_public_path__ + "x.png?7202f0a1cffa226c7c344787b7fb2120";


//////////////////
// WEBPACK FOOTER
// ./src/assets/x.png
// module id = 776
// module chunks = 0